import { useState } from "react";
import logoUrl from "../../branding/YahshiWeblogo.png";
import "./BrandLogo.css";

type BrandLogoProps = {
  className?: string;
  alt?: string;
};

export function BrandLogo({ className = "yahshi-logo", alt = "" }: BrandLogoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className={`yahshi-mark ${className}`} aria-hidden={alt ? undefined : true} {...(alt ? { "aria-label": alt } : {})}>
        Y
      </span>
    );
  }
  return <img className={className} src={logoUrl} alt={alt} onError={() => setFailed(true)} />;
}
